export default "__VITE_ASSET__Dr9xB4l0__"